"use strict";

var _toConsumableArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var Storage = /*#__PURE__*/function () {
  function Storage(options) {
    var adapter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Storage);

    this.options = options;
    this.adapter = adapter; //
  }

  _createClass(Storage, [{
    key: "createChild",
    value: function createChild(namespace) {
      return new Storage({
        namespace: this.prepareKey(namespace)
      }, this.adapter);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, adapterKey, raw;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = null;

                if (!this.adapter) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 2;
                adapterKey = this.prepareKey(key);
                _context.next = 6;
                return Promise.resolve(this.adapter.getItem(adapterKey));

              case 6:
                raw = _context.sent;

                if (raw) {
                  result = JSON.parse(raw, utils_1.jsonReviver);
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                result = null;

              case 13:
                return _context.abrupt("return", result || null);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));
    }
  }, {
    key: "setItem",
    value: function setItem(key, item) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var adapterKey, raw;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (item) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.removeItem(key));

              case 2:
                if (!this.adapter) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 3;
                adapterKey = this.prepareKey(key);
                raw = JSON.stringify(item, utils_1.jsonReplacer);
                _context2.next = 8;
                return Promise.resolve(this.adapter.setItem(adapterKey, raw));

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var adapterKey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.adapter) {
                  _context3.next = 9;
                  break;
                }

                _context3.prev = 1;
                adapterKey = this.prepareKey(key);
                _context3.next = 5;
                return Promise.resolve(this.adapter.removeItem(adapterKey));

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));
    }
  }, {
    key: "prepareKey",
    value: function prepareKey(key) {
      var namespace = this.options.namespace;
      var parts = Array.isArray(key) ? key : [key];

      if (namespace) {
        parts = [namespace].concat(_toConsumableArray(parts));
      }

      return parts.join(Storage.SEPARATOR);
    }
  }]);

  return Storage;
}();

Storage.SEPARATOR = ':';
exports.Storage = Storage;